export default __webpack_public_path__ + "static/media/Timeline-GiftBoxes-15.21b325ef.png";